import React, { createContext, useContext, useState } from 'react';
import CustomSnackbar from '../components/CustomSnackbar';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [showSB, setShowSB] = useState({ open: false, color: 'info', title: "", content: "", dateTime: null });

    const closeNotification = () => setShowSB({ ...showSB, open: false });

    const showNotification = (color, title, content, dateTime = null) => {
        setShowSB({ open: true, color, title, content, dateTime });
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            <CustomSnackbar
                color={showSB.color}
                icon={
                    showSB.color === "red" ? 'red' :
                    showSB.color === "red" ? 'red' :
                    showSB.color === "red" ? 'red' :
                    'notifications'
                }
                title={showSB.title}
                content={showSB.content}
                dateTime={showSB.dateTime}
                open={showSB.open}
                onClose={closeNotification}
                close={closeNotification}
            />
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);
